import { useMemo } from "react";
import PropTypes from 'prop-types';
import {CDataTable, CCard, CCardBody, CCardHeader} from "@coreui/react";
import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {faLayerGroup} from "@fortawesome/pro-light-svg-icons";
import { useTranslation } from "react-i18next";
import noop from "../../utils/noop";
import {ActionToolbar } from "../Toolbars/ActionToolbar";
import StatusCell from "../StatusCell";
import {useColumnFilter} from "../../hooks/useColumnFilter";
import {tableFilterObject} from "../../common/tableFilterObject";
import ActionsCell from "../ActionsCell";

export const ProductGroupList = ({records, onAddClick, onEditClick, onDeleteClick, onHistoryClick,  onImportClick, loading, exportHref }) => {
    
    const {t} = useTranslation(["ProductGroupList", "Common"]);

    const columnFilter = useColumnFilter();
    
    const fields = useMemo(() => ([
            { key: "id", label:t("Common:id") },
            { key: "is_active", label: t("Common:activeColName") },
            { key: "name", label: t("ProductGroupList:name"), _classes: "text-nowrap w-100" },
            { key: "rccp", label:t("ProductGroupList:rccp"),  _classes: "text-nowrap" },
            { key: "work_center", label:t("ProductGroupList:workCenter"),  _classes: "text-nowrap" },
            { key: "gl_cat", label:t("ProductGroupList:glCat"),  _classes: "text-nowrap" },
            { key: "_group_key", label:t("ProductGroupList:groupKey"),  _classes: "text-nowrap" },
            { key: "_actions", label: t("Common:actions"), sorter: false, filter: false },
        ]),[t]);
    
    return (         
        <CCard>
            <CCardHeader>
                <div className="d-flex flex-row">
                    <h2 className="mr-2 d-flex flex-row align-items-center"><FontAwesomeIcon icon={faLayerGroup} className="mr-2"/>{t("ProductGroupList:productGroup")}</h2>
                    <div className="ml-auto d-flex">
                        <ActionToolbar className="ml-auto" onAddClick={onAddClick} onImportClick={onImportClick} exportHref={exportHref}/>
                    </div>
                </div>
            </CCardHeader>
            <CCardBody>
                <CDataTable
                    size="md"
                    tableFilter={tableFilterObject(t)}
                    cleaner
                    itemsPerPageSelect
                    itemsPerPage={10}
                    columnFilter={columnFilter}
                    footer
                    sorter
                    striped
                    hover
                    responsive
                    pagination
                    noItemsViewSlot={<div>{t("Common:noRecordsFound")}</div>}
                    items={records} fields={fields}
                    loading={loading}
                    scopedSlots={{
                        is_active: item => <StatusCell active={item.is_active} />,
                        _group_key: item => <td>{item.rccp}{item.gl_cat}</td>,
                        _actions: item => <ActionsCell onEditClick={() => onEditClick(item)} onDeleteClick={() => onDeleteClick(item)} onHistoryClick={() => onHistoryClick(item)}/>
                        
                    }}
                />
            </CCardBody>
        </CCard>
        
    );
};

ProductGroupList.propTypes = {
    records: PropTypes.array,
    loading: PropTypes.bool,
    exportHref: PropTypes.string,
    onAddClick: PropTypes.func,
    onEditClick: PropTypes.func,
    onDeleteClick: PropTypes.func,
    onHistoryClick: PropTypes.func,
    onImportClick: PropTypes.func,
    onExportClick: PropTypes.func
};

ProductGroupList.defaultProps = {
    records: [],
    loading: false,
    exportHref: "",
    onAddClick: noop,
    onEditClick: noop,
    onDeleteClick: noop,
    onHistoryClick: noop,
    onImportClick: noop,
    onExportClick: noop,
};

export default ProductGroupList;